import React from "react";
import "./Erp.css";
function Erp(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="inventory.png" alt="Logo"/>
           Inventory & Stock Management</h5>
          <p className="card-text">We build ERP modules that let you track your inventory in real time. Monitor stock levels, automate reordering, and avoid overstocking or stockouts. Our system helps you maintain accurate records and streamline your supply chain efficiently.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="sales.png" alt="Logo"/>
            Sales & Billing Management</h5>
          <p className="card-text">Our ERP system allows you to manage the complete sales cycle—from quotation to invoice—with just a few clicks. Generate professional invoices, track payments, and access customer history instantly, making your sales process smooth and accurate.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="production.png" alt="Logo"/>
             Production & Manufacturing</h5>
          <p className="card-text">For manufacturers, we provide complete production planning, raw material tracking, and process monitoring within the ERP. This helps reduce delays, manage job orders, and improve overall production flow.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="finance.png" alt="Logo"/>
            Finance & Accounting</h5>
          <p className="card-text">Handle your business finances with confidence. Our ERP accounting module includes expense tracking, profit/loss reports, balance sheets, and GST-enabled billing. Get full control over your financial health in one dashboard.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="purchase.png" alt="Logo"/>
           Purchase & Vendor Management</h5>
          <p className="card-text">Manage purchase orders, vendor records, and supplier payments all in one place. Our ERP ensures smoother coordination with vendors, tracks delivery timelines, and keeps your procurement process transparent and efficient.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Erp;